/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IMoeKwrResourceinfo contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum resourceInfoStyle {
    vertical = 'vertical',
    horizontal = 'horizontal'
}

export const enum typeOfResource {
    video = 'video',
    audio = 'audio',
    digitalInteractive = 'digitalInteractive',
    mobileApp = 'mobileApp',
    web = 'web'
}

export interface IMoeKwrResourceinfoConfig extends Msdyn365.IModuleConfig {
    resourceTitle?: string;
    resourceImage?: Msdyn365.IImageData;
    resourceInfoStyle?: resourceInfoStyle;
    typeOfResource?: typeOfResource;
}

export interface IMoeKwrResourceinfoResources {
    videoIconName: string;
    videoIconNameInMaori: string;
    mobileAppIconName: string;
    mobileAppIconNameInMaori: string;
    digitalInteractiveIconName: string;
    digitalInteractiveIconNameInMaori: string;
    webIconName: string;
    webIconNameInMaori: string;
}

export interface IMoeKwrResourceinfoProps<T> extends Msdyn365.IModule<T> {
    resources: IMoeKwrResourceinfoResources;
    config: IMoeKwrResourceinfoConfig;
}
